<style scoped>
.custom-background-color {
  background-color: #0000004f !important;
}

.title-header {
  padding-top: 1rem !important;
  line-height: 24px !important;
  padding-bottom: 14px;
  background-color: #f0f1f2;
}

.top-missing-documents-header {
  display: flex;
}

.documents-list {
  margin: 0;
}

>>> .content-align-middle {
  vertical-align: middle;
}

</style>

<template>
  <div class="container raised">
    <b-row>
      <b-col>
        <b-row class="title-header mb-3">
          <b-col class="top-missing-documents-header">
            <div>
              Outstanding Documents - For New Deals in Process
            </div>
          </b-col>
        </b-row>

        <b-col>
          <loading-component
            :url="`/users/${this.$store.getters.user.id}/top_missing_documents`"
            :auto-request="user.verified"
            errorMessage="Unable to load Outstanding Documents"
            @success="topMissingDocs = $event"
          >
            <b-row>
              <b-col>
                <h5>Loans</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <filter-table
                  :fields="loanFields"
                  :slots="templates"
                  :items="topLoans"
                  :show-filter="false"
                  :clickable="true"
                  :empty-text="emptyText"
                  @row-clicked="dealsClicked">
                  <template slot="loan" slot-scope="row">
                    <span class="btn-link">{{row.value}}</span>
                  </template>
                  <template slot="document" slot-scope="row">
                    <p
                      class="documents-list"
                      v-for="document in row.value"
                      :key="document.id"
                    >
                      {{document}}
                    </p>
                  </template>
                  <template slot="percentage_to_funded" slot-scope="row">
                    <b-progress
                      v-b-tooltip.hover
                      :title="row.value"
                      animated
                      class="custom-background-color"
                    >
                      <b-progress-bar :value="row.value"/>
                    </b-progress>
                  </template>
                </filter-table>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h5>Entities</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <filter-table
                  :fields="entitiesFields"
                  :slots="templates"
                  :items="topEntities"
                  :show-filter="false"
                  :clickable="true"
                  :empty-text="emptyText"
                  @row-clicked="entitiesClicked">
                  <template slot="loan" slot-scope="row">
                    <span class="btn-link">{{row.value}}</span>
                  </template>
                  <template slot="document" slot-scope="record" >
                    <p
                      class="documents-list"
                      v-for="document in record.value"
                      :key="document.id"
                    >
                      {{document}}
                    </p>
                  </template>
                  <template slot="percentage_to_funded" slot-scope="row">
                    <b-progress
                      v-b-tooltip.hover
                      :title="row.value"
                      animated
                      class="custom-background-color"
                    >
                      <b-progress-bar :value="row.value">
                      </b-progress-bar>
                    </b-progress>
                  </template>
                </filter-table>
              </b-col>
            </b-row>
          </loading-component>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Badge from '@/components/utils/Badge';
import LoadingComponent from '@/components/utils/LoadingComponent';
import FilterTable from '@/components/utils/FilterTable';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUpload } from '@fortawesome/free-solid-svg-icons';

library.add([faUpload]);

export default {
  components: {
    Badge,
    LoadingComponent,
    FilterTable,
  },
  data() {
    return {
      topMissingDocs: {
        loans: [],
        entities: [],
      },
      templates: [
        { key: 'document' },
        { key: 'loan' },
        { key: 'percentage_to_funded' },
      ],
      loanFields: [
        {
          key: 'loan',
          label: 'Loan Number',
          tdClass: 'content-align-middle',
        },
        {
          key: 'address',
          label: 'Address',
          tdClass: 'content-align-middle',
        },
        {
          key: 'percentage_to_funded',
          label: 'Progress',
          tdClass: 'content-align-middle',
        },
      ],
      entitiesFields: [
        {
          key: 'loan',
          label: 'Used on Loan',
          tdClass: 'content-align-middle',
        },
        {
          key: 'address',
          label: 'Address',
          tdClass: 'content-align-middle',
        },
        {
          key: 'percentage_to_funded',
          label: 'Progress',
          tdClass: 'content-align-middle',
        },
      ],
      emptyText: 'Your pending documents will be listed here as soon as they are required',
    };
  },
  methods: {
    dealsClicked(deals) {
      this.$router.push({ name: 'DealDetail', params: { loan_id: deals.id } });
    },
    entitiesClicked(entity) {
      this.$router.push({ name: 'EntityDetails', params: { id: entity.id } });
    },
  },
  computed: {
    topLoans() {
      const deals = [];
      this.topMissingDocs.loans.forEach((item) => {
        deals.push({
          id: item.id,
          loan: item.loan,
          address: item.address,
          document: item.document,
          needed_documents_count: item.needed_documents_count,
          percentage_to_funded: item.percentage_to_funded * 100 });
      });
      return deals;
    },
    topEntities() {
      const entities = [];
      this.topMissingDocs.entities.forEach((item) => {
        entities.push({
          id: item.id,
          loan: item.loan,
          address: item.address,
          document: item.document,
          needed_documents_count: item.needed_documents_count,
          percentage_to_funded: item.percentage_to_funded * 100,
        });
      });
      return entities;
    },
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    topMissingDocs() {
      const sumLoans = this.topLoans.reduce((total, deal) =>
        total + deal.needed_documents_count, 0);
      const sumEntities = this.topEntities.reduce((total, deal) =>
        total + deal.needed_documents_count, 0);
      const total = sumLoans + sumEntities;
      this.$emit('missingDocumentsCount', total);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/top_missing_documents/TopMissingDocuments.vue